import { env } from '@/env';

// Register key doubles as the GBMW tab path segment (Expo Router route group
// (tabs) is stripped from the web URL, so the path is /<register>).
export type ShareableRegister = 'schedule-checks' | 'issues' | 'work-orders';

// Deep-link a shared register into its matching GBMW tab. Returns null when the
// GBMW base URL isn't configured (VITE_GBMW_URL is optional) so callers hide the
// share affordance rather than build an `undefined/...` link.
export function getGbmwShareUrl(register: ShareableRegister): string | null {
  if (!env.VITE_GBMW_URL) return null;
  return `${env.VITE_GBMW_URL}/${register}`;
}

// GBMW web app root, for the "Open Mechanic App" affordance. Null when unset, so
// callers hide the button rather than open `undefined`.
export function getGbmwAppUrl(): string | null {
  return env.VITE_GBMW_URL ?? null;
}

export type ShareTargets = { shareUrl: string | null; appUrl: string | null };

// The share/mechanic-app URLs for a register — deep-link into GBMW.
export function getShareTargets(register: ShareableRegister): ShareTargets {
  return { shareUrl: getGbmwShareUrl(register), appUrl: getGbmwAppUrl() };
}
